import { createSelector } from 'reselect';
import {
    activeTeamIdsSelector,
    clientSelector,
    userIdSelector
} from 'common/redux/selectors/queryParamsSelectors';
import { UserStatusEnum } from 'common/enums/UserTabsStatusEnum';

import { mapFromList } from 'common/utils/ImmutableUtils';

import * as Immutable from 'immutable';

export const userSelector = createSelector(
    [
        (state, props) =>
            state.users.getIn([
                clientSelector(state, props),
                'users',
                'entity'
            ]),
        state => state.team.getIn(['records'])
    ],
    (usersEntity, teams) => {
        if (usersEntity) {
            return usersEntity.map(user => {
                const userTeams = user.teams;
                let userInstance = user;
                const updatedUserTeams = userTeams.map(userTeam => {
                    const team = teams.getIn([
                        userTeam.clientId,
                        userTeam.teamId
                    ]);
                    return team;
                });
                userInstance = user.setTeams(updatedUserTeams);
                return userInstance;
            });
        }
        return Immutable.List();
    }
);

export const usersMapSelector = createSelector([userSelector], users => {
    return mapFromList(users, 'userId');
});

const getUsersByStatus = (users, status, teamIds) => {
    let filteredUsers = Immutable.List();
    switch (status) {
        case 'WORKING':
            filteredUsers = users.filter(user => {
                if (
                    user.effectiveStatus.effectiveStatus !==
                    UserStatusEnum.DISABLED
                ) {
                    return (
                        user.effectiveStatus &&
                        !!user.effectiveStatus.isRelevantToday
                    );
                }
            });
            break;
        case 'IDLE':
            filteredUsers = users.filter(user => {
                if (
                    user.effectiveStatus.effectiveStatus !==
                    UserStatusEnum.DISABLED
                ) {
                    return (
                        user.effectiveStatus &&
                        !user.effectiveStatus.isRelevantToday
                    );
                }
            });
            break;
    }

    if (teamIds && teamIds.length > 0) {
        filteredUsers = filteredUsers.filter(user => {
            return (
                user.teams.filter(team => {
                    return team && teamIds.indexOf(team.get('teamId')) !== -1;
                }).size !== 0
            );
        });
    }
    return filteredUsers;
};
export const getWorkingUsers = createSelector(
    [
        () => 'WORKING',
        (state, props) => userSelector(state, props),
        activeTeamIdsSelector
    ],
    (status, users, teamIds) => {
        return getUsersByStatus(users, status, teamIds);
    }
);
export const getIdleUsers = createSelector(
    [
        () => 'IDLE',
        (state, props) => userSelector(state, props),
        activeTeamIdsSelector
    ],
    (status, users, teamIds) => {
        return getUsersByStatus(users, status, teamIds);
    }
);

export const getUserById = createSelector(
    [userSelector, userIdSelector, clientSelector],
    (users, userId, clientId) => {
        return users
            .filter(
                user => user.userId === userId && user.clientId === clientId
            )
            .get(0);
    }
);

export const getUserListLoadingStatus = (state, props) => {
    return state.users.getIn([
        clientSelector(state, props),
        'users',
        'status',
        'isRiderListLoading'
    ]);
};
